import { getExecEndpoint } from '../../../service/getExecEndpoint';
import { defaultServer } from '~/api/def/servers/defaultServer';

export const documentLivenessEndpoint = {
  server: defaultServer,
  path: 'documents/toggle-liveness',
  description: 'Run document extraction',
};

const endpointRunDocumentExtractionGetExec =
  getExecEndpoint<DocumentLivenessEndpointDef>(documentLivenessEndpoint);
export const documentLivenessEndpointPOST = async (
  urlExtra: string,
  payload: DocumentLivenessRequest,
) =>
  endpointRunDocumentExtractionGetExec<'POST'>({
    method: 'POST',
    urlExtra: urlExtra,
    payload: payload,
  });
export interface DocumentLivenessEndpointDef {
  endpoint: typeof documentLivenessEndpoint;
  methods: {
    POST: {
      response: DocumentLivenessResponse;
      payload: DocumentLivenessRequest;
    };
  };
}
export interface DocumentLivenessRequest {
  liveness: boolean;
  documentId: string;
}

export type DocumentLivenessResponse =
  | {
      success: true;
    }
  | {
      success: false;
      error?: string;
    };
